import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';

import Navbar from './common/Navbar';
import BookTools from './book/BookTools';
import BookTable from './book/BookTable';
import BookForm from './book/BookForm';
import BookMy from './book/BookMy';

import * as action from '../actions';
import * as selector from '../selectors';

const mapStateToProps = (state, ownProps) => {
	const m = selector.getMomentTimezoneOffset(state);
	return {
		date: ownProps.match.params.date || m.format('YYYY-MM-DD'),
		selectedIntervals: selector.getSelectedIntervals(state),
		settings: selector.getSettings(state),
	};
};
const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		calcIntervals: action.calcIntervals,
	}, dispatch);
};

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		date: PropTypes.string,
		selectedIntervals: PropTypes.array,
		settings: PropTypes.object,
		calcIntervals: PropTypes.func,
	}

	constructor(props) {
		super(props);
		this.state = {
			taskIndex: null,
		};
	}

	componentDidMount() {
		const {
			settings,
			calcIntervals,
		} = this.props;

		const taskIndex = setInterval(() => {
			const date = this.props.date; // чтобы при смене дня получать актуальную дату
			calcIntervals({date, settings});
		}, 60000);

		this.setState({taskIndex});
	}

	componentWillUnmount() {
		const {taskIndex} = this.state;

		if (taskIndex) {
			clearInterval(taskIndex);
		}
	}

	render() {
		const {
			date,
			selectedIntervals,
		} = this.props;

		const className = 'content booking' + (selectedIntervals.length ? ' with_form' : '');

		return (
			<div className={className}>
				<Navbar />
				<BookMy />
				<BookTools date={date} />
				<BookTable date={date} />
				<BookForm date={date} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Book.js